import { Box, Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import { Search, X } from 'lucide-react';
import { SEARCH_MAX_LENGTH } from '@/constants/contentFeed';
import { text } from '@/theme/colors/palettes';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

// Inline feed search. The query lives in the feed's component state, never the URL —
// search terms over a wellness library are health-adjacent, so keeping them out of
// history/referrers/analytics is the whole posture (the request param is separately
// scrubbed from error reporting).
const FeedSearchInput = ({ value, onChange }: Props) => (
  <InputGroup width={{ base: '100%', md: '240px' }}>
    <InputLeftElement pointerEvents="none" color={text.mediumBlue} height="42px">
      <Search size={16} />
    </InputLeftElement>
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search"
      aria-label="Search content"
      autoComplete="off"
      // Backend caps `q` at 100 chars; stop the input there rather than 400ing.
      maxLength={SEARCH_MAX_LENGTH}
      height="42px"
      borderRadius="full"
      backgroundColor="white"
      border="none"
      boxShadow="0px 4px 16px rgba(14, 0, 98, 0.07)"
      _focusVisible={{ boxShadow: '0px 4px 16px rgba(14, 0, 98, 0.07), inset 0 0 0 2px var(--chakra-colors-primary-300)' }}
    />
    {value && (
      <InputRightElement height="42px">
        <Box
          as="button"
          type="button"
          aria-label="Clear search"
          onClick={() => onChange('')}
          display="flex"
          alignItems="center"
          justifyContent="center"
          color={text.mediumBlue}
          _hover={{ color: 'extra.red' }}
        >
          <X size={16} />
        </Box>
      </InputRightElement>
    )}
  </InputGroup>
);

export default FeedSearchInput;
